import { FloorLookUp } from '../../constants/actionTypes';

export const updateFloor = (floorNo, dispatch, status = false) => {
  dispatch({ type: FloorLookUp.UPDATE_FLOOR_NUMBER, value: { floorNo, status } });
};
